import React, { useState, useRef, useEffect } from 'react';
import { FiMenu, FiBell, FiUser, FiSettings, FiLogOut, FiSun, FiMoon } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ onMenuClick, title }) => {
  const { user, logout } = useAuth();
  const { isDarkMode, toggleDarkMode } = useTheme();
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const profileRef = useRef(null);
  const notificationRef = useRef(null);

  // Mock notifications
  const notifications = [
    { id: 1, message: 'New blog post published', time: '5 min ago', read: false },
    { id: 2, message: 'New review received', time: '1 hour ago', read: false },
    { id: 3, message: 'Client logo updated', time: '3 hours ago', read: true },
  ];

  const unreadCount = notifications.filter(n => !n.read).length;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="navbar">
      <div className="navbar-left">
        <button className="menu-toggle" onClick={onMenuClick}>
          <FiMenu />
        </button>
        <h1 className="page-title">{title}</h1>
      </div>

      <div className="navbar-right">
        {/* Dark Mode Toggle */}
        <button className="theme-toggle" onClick={toggleDarkMode} title={isDarkMode ? 'Light Mode' : 'Dark Mode'}>
          {isDarkMode ? <FiSun /> : <FiMoon />}
        </button>

        {/* Notifications */}
        <div className="notification-wrapper" ref={notificationRef}>
          <button 
            className="notification-btn"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <FiBell />
            {unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </button>
          
          {showNotifications && (
            <div className="notification-dropdown">
              <div className="dropdown-header">
                <h3>Notifications</h3>
                {unreadCount > 0 && (
                  <span className="unread-count">{unreadCount} new</span>
                )}
              </div>
              <div className="notification-list">
                {notifications.map(notification => (
                  <div 
                    key={notification.id} 
                    className={`notification-item ${!notification.read ? 'unread' : ''}`}
                  >
                    <p className="notification-message">{notification.message}</p>
                    <span className="notification-time">{notification.time}</span>
                  </div>
                ))}
              </div>
              <button className="view-all-btn">View all notifications</button>
            </div>
          )}
        </div>

        {/* Profile Menu */}
        <div className="profile-wrapper" ref={profileRef}>
          <button 
            className="profile-btn"
            onClick={() => setShowProfileMenu(!showProfileMenu)}
          >
            <div className="profile-avatar">
              {user?.avatar ? (
                <img src={user.avatar} alt={user.name} />
              ) : (
                <FiUser />
              )}
            </div>
            <span className="profile-name">{user?.name || 'Admin'}</span>
          </button>
          
          {showProfileMenu && (
            <div className="profile-dropdown">
              <div className="dropdown-user-info">
                <div className="user-avatar">
                  {user?.avatar ? (
                    <img src={user.avatar} alt={user.name} />
                  ) : (
                    <FiUser />
                  )}
                </div>
                <div className="user-details">
                  <p className="user-name">{user?.name || 'Admin User'}</p>
                  <p className="user-email">{user?.email || 'admin@designinfra.co.in'}</p>
                </div>
              </div>
              <hr className="dropdown-divider" />
              <button className="dropdown-item">
                <FiSettings />
                <span>Settings</span>
              </button>
              <button className="dropdown-item logout" onClick={handleLogout}>
                <FiLogOut />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
